module.exports = __webpack_public_path__ + "img/G2.5650950f.gif";